import { Repository } from "./adapters/repository";

import * as retrieveWorkLoads from "./useCases/retrieveWorkLoads";

enum UseCases {
  retrieveWorkLoads = "retrieveWorkLoads",
}

interface Core {
  [UseCases.retrieveWorkLoads]: retrieveWorkLoads.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = { repository: Repository };

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.retrieveWorkLoads]: retrieveWorkLoads.createInteractor(
      dependencies.repository,
    ),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
